import type { SessionSummary } from '@features/customization-session/types';

const MetaTile = ({ label, value, accent }: { label: string; value: string | number; accent?: string }) => (
  <div
    className="flex min-w-0 flex-1 flex-col gap-1 rounded-xl border border-l-[6px] bg-card px-5 py-4"
    style={
      accent
        ? {
            borderColor: `color-mix(in srgb, ${accent} 50%, transparent)`,
            borderLeftColor: accent,
            backgroundColor: `color-mix(in srgb, ${accent} 8%, transparent)`,
          }
        : { borderLeftColor: 'var(--primary)' }
    }
  >
    <dt className="text-xs font-bold tracking-wider text-muted-foreground uppercase">{label}</dt>
    <dd className="m-0 truncate text-[2rem] leading-tight font-bold tabular-nums" title={String(value)}>
      {value}
    </dd>
  </div>
);

/** The three things the operator checks first: the machine to go to, the jig to take, the number of products. */
export const SessionMeta = ({ summary }: { summary: SessionSummary }) => (
  <dl className="m-0 flex gap-4">
    <MetaTile accent={summary.machineColor} label="Machine" value={summary.machine} />
    <MetaTile label="Gabarit" value={summary.jig} />
    <MetaTile label="Produits" value={summary.quantity} />
  </dl>
);
